/** Key for `sessionStorage` entry after a successful sign-in. */
export const SESSION_KEY = 'cm_session';

export function readAccessToken(): string | null {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw) as {access_token?: string};
    return typeof data.access_token === 'string' && data.access_token.length > 0
      ? data.access_token
      : null;
  } catch {
    return null;
  }
}
